import { LoadableAfterPaint } from '@confluence/loadable';

export const DetailsSummaryExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DetailsSummaryExtensionHandler" */ '../src/DetailsSummaryExtensionHandler.tsx'
			)
		).DetailsSummaryExtensionHandler,
});
